import { render, staticRenderFns } from "./DisabledHealthFirstPlate.vue?vue&type=template&id=2f364fe7&"
import script from "./DisabledHealthFirstPlate.vue?vue&type=script&lang=js&"
export * from "./DisabledHealthFirstPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports